import React, { useEffect, useState, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, Key, PenTool, Lock } from 'lucide-react'; // Add Lock to imports
import { useAuth } from '../Auth/useAuth';
import { cookieUtils, eventEmitter, SDK_TOKEN_EVENT } from '../API/ApiService';

const Sidebar = ({ activeSection, onSectionChange }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  const [menuItems, setMenuItems] = useState([
    { id: 'app-keys', label: 'App Keys', icon: Key, enabled: true },
    { id: 'demo-screen', label: 'Mock Demo', icon: FileText, enabled: false },
    { id: 'documents', label: 'Audit Logs', icon: PenTool, enabled: false },
  ]);

  // Memoize updateMenuState
  const updateMenuState = useCallback(() => {
    const sdkToken = cookieUtils.get('sdkToken');
    setMenuItems(prevItems => 
      prevItems.map(item => ({
        ...item,
        enabled: item.id === 'app-keys' ? true : !!sdkToken
      }))
    );
  }, []);

  // Initial URL sync - run only once on mount
  useEffect(() => {
    const currentPath = location.pathname.split('/').pop();
    if (currentPath && currentPath !== activeSection) {
      onSectionChange(currentPath);
    }
  }, []);

  useEffect(() => {
    updateMenuState();
    const unsubscribe = eventEmitter.subscribe(SDK_TOKEN_EVENT, updateMenuState);
    return () => unsubscribe();
  }, [isAuthenticated, updateMenuState]);

  return (
    <div className="w-64 bg-white shadow-sm h-screen sticky top-0">
      <div className="p-6">
        <nav className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isDisabled = !item.enabled;
            const isActive = location.pathname.includes(item.id);
            
            return (
              <Link
                key={item.id}
                to={`/dashboard/${item.id}`}
                onClick={(e) => {
                  if (isDisabled) {
                    e.preventDefault();
                    return;
                  }
                  onSectionChange(item.id);
                }}
                className={`flex items-center w-full px-4 py-3 text-left rounded-lg transition duration-200 ${
                  isActive && item.enabled
                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                    : item.enabled
                    ? 'text-gray-700 hover:bg-gray-50'
                    : 'text-gray-400 cursor-not-allowed'
                }`}
              >
                <Icon size={20} className="mr-3" />
                {item.label}
                {isDisabled && (
                  <Lock 
                    size={16} 
                    className="ml-auto text-gray-400" 
                    aria-label="Locked"
                  />
                )}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;